class KlaviyoBis extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[type="submit"]');
    if (!this.form || !this.submitButton) return;

    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.url = {
      id: 'https://a.klaviyo.com/client/subscriptions',
      email: 'https://a.klaviyo.com/client/back-in-stock-subscriptions'
    };
    this.errorPlace = this.querySelector('[data-error-message]');
  }

  getProductVarianId() {
    const { variantId, variantIdSelector, variantIdSelectorDataset } = this.dataset;
    
    if (variantId) return variantId;

    if (!variantIdSelector || !variantIdSelectorDataset) return '';

    const parent = this.closest(variantIdSelector);
    return parent ? parent.dataset[variantIdSelectorDataset] : '';
  }

  showError(message) {
    const errorContainer = this.querySelector('.error-message');
    const errorMessage = this.querySelector('.form-errors');
    
    if (errorContainer) {
      errorContainer.textContent = message;
    }
    if (errorMessage) {
      errorMessage.classList.remove('hidden');
    }
    
    const successMessage = this.querySelector('.form-success');
    if (successMessage) {
      successMessage.classList.add('hidden');
    }
  }

  showSuccess() {
    const successMessage = this.querySelector('.form-success');
    const errorMessage = this.querySelector('.form-errors');
    
    if (successMessage) {
      successMessage.classList.remove('hidden');
    }
    if (errorMessage) {
      errorMessage.classList.add('hidden');
    }
  }

  hideMessages() {
    const successMessage = this.querySelector('.form-success');
    const errorMessage = this.querySelector('.form-errors');
    
    if (successMessage) {
      successMessage.classList.add('hidden');
    }
    if (errorMessage) {
      errorMessage.classList.add('hidden');
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    event.stopPropagation();
    
    if (!this.form || !this.dataset.api || !this.dataset.revision) {
      console.error('Missing required data attributes');
      return;
    }

    const formData = new FormData(this.form);
    const email = formData.get('email');
    const revision = this.dataset.revision;

    this.submitButton.setAttribute('aria-disabled', 'true');
    this.submitButton.classList.add('is-loading');

    const requestParameters = new URLSearchParams({
      company_id: this.dataset.api
    });
    
    const backInStockOption = {
      method: 'POST',
      headers: {
        revision: revision,
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.getProductVarianId()}` } }
          }
        }
      })
    };    
        
    (async () => {
      try {
        const response = await fetch(`${this.url.email}?${requestParameters}`, backInStockOption);
        
        if (response.ok) {
          this.showSuccess();
          this.form.reset();
        } else {
          const errorData = await response.json();
          console.error('Klaviyo API error:', errorData);
          this.showError();
        }
      } catch (error) {
        this.showError();
      }

      this.submitButton.setAttribute('aria-disabled', 'false');
      this.submitButton.classList.remove('is-loading');
      
      setTimeout(() => {
        this.hideMessages();
      }, 5000);
    })();
  }
}

if (!customElements.get('klaviyo-bis')) {
  customElements.define('klaviyo-bis', KlaviyoBis);
}

